// src/modules/ida/components/FilePreviewChips.test.tsx
//
// Unit tests for IDA chat file preview chips.

import React from "react";
import { render, screen, fireEvent } from "@testing-library/react";
import "@testing-library/jest-dom";
import { FilePreviewChips, isAllowedFile } from "./FilePreviewChips";

describe("FilePreviewChips", () => {
  it("accepts legacy PowerPoint attachments supported by the API", () => {
    expect(isAllowedFile("slides.ppt")).toBe(true);
  });

  const files = [
    {
      filename: "screenshot-2026-04-17-102030.jpg",
      fileSize: 123456,
      mimeType: "image/jpeg",
      thumbnailUrl: "blob:http://localhost/screenshot",
    },
  ];

  it("removes an attached screenshot when the chip delete button is clicked", () => {
    const onRemove = jest.fn();

    render(<FilePreviewChips files={files} onRemove={onRemove} />);

    fireEvent.click(
      screen.getByRole("button", {
        name: "Remove screenshot-2026-04-17-102030.jpg",
      }),
    );

    expect(onRemove).toHaveBeenCalledTimes(1);
    expect(onRemove).toHaveBeenCalledWith(0);
  });

  it("does not render delete buttons when disabled", () => {
    render(<FilePreviewChips files={files} onRemove={jest.fn()} disabled />);

    expect(
      screen.queryByRole("button", {
        name: "Remove screenshot-2026-04-17-102030.jpg",
      }),
    ).not.toBeInTheDocument();
  });
});
